// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-layout { 
  display: flex;  
  min-height: 100vh;  
  background-color: #0f172a;
}

.sidebar { 
  width: 250px; 
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%); 
  color: #ffffff; 
  position: fixed; 
  top: 0; 
  left: 0; 
  bottom: 0; 
  z-index: 1000; 
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1); 
  transform: translateX(-100%); 
  display: flex; 
  flex-direction: column; 
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 10px 0 30px rgba(0, 0, 0, 0.3); 
  overflow: hidden;
}

.sidebar-divider {
  padding: 15px 20px 5px;
  font-size: 11px;
  text-transform: uppercase;
  color: #6c757d;
  font-weight: bold;
  letter-spacing: 1px;
  border-top: 1px solid #343a40;
  margin-top: 10px;
}

.admin-nav-item .nav-icon.text-warning {
  color: #ffc107;
}

.sidebar.visible { transform: translateX(0); }

.sidebar-header { 
  padding: 25px 15px;
  background: rgba(255, 255, 255, 0.02);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05); 
}

.brand-container { display: flex; flex-direction: column; align-items: center;  justify-content: center; text-align: center; }
.sidebar-logo { height: 40px;  width: auto; margin-bottom: 12px; filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3)); }
.brand-slogan { font-size: 12px; font-weight: 400; color: #94a3b8; margin: 0; line-height: 1.4; font-style: italic; max-width: 190px; }

.sidebar-nav { 
  flex: 1 1; 
  padding: 15px 12px; 
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-item { 
  display: flex; 
  align-items: center; 
  padding: 10px 14px; 
  color: #94a3b8; 
  text-decoration: none; 
  border-radius: 10px; 
  transition: all 0.3s ease; 
  font-size: 14px; 
  font-weight: 500;
}

.nav-item:hover { 
  background-color: rgba(59, 130, 246, 0.1); 
  color: #3b82f6; 
  padding-left: 18px;
}

.nav-icon {
  width: 20px;
  margin-right: 12px;
  font-size: 1.1rem;
}

.sidebar-toggle-btn {
  position: fixed;
  top: 15px;
  z-index: 1100;
  width: 32px;
  height: 32px;
  background-color: #ffffff;
  color: #1e293b;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  /* JS inline style left handle korbe (15px or 235px) */
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s;
}

.sidebar-toggle-btn:hover {
  background-color: #38bdf8;
  color: white;
}

.main-content {
  flex: 1 1;
  padding: 30px;
  padding-top: 70px;
  transition: margin-left 0.3s ease;
  width: 100%;
}

.sidebar-footer {
  padding: 10px;
  background-color: #0f172a;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.lang-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #94a3b8;
  font-size: 14px;
}

.lang-box select {
  background: #1e293b;
  color: #fff;
  border: 1px solid #334155;
  border-radius: 6px;
  padding: 4px 8px;
  outline: none;
  cursor: pointer;
}

.logout-button {
  width: 100%;
  padding: 10px;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s;
}

.logout-button:hover {
  background-color: #dc2626;
}

.mr-2 { margin-right: 8px; }

@media (min-width: 769px) {
  .sidebar-open {
    margin-left: 240px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,aAAa;EACb,uDAAuD;EACvD,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB,wBAAwB,EAAE;;AAE7C;EACE,kBAAkB;EAClB,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,GAAG,uBAAuB,EAAE,kBAAkB,EAAE;AAC7H,gBAAgB,YAAY,GAAG,WAAW,EAAE,mBAAmB,EAAE,iDAAiD,EAAE;AACpH,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEtI;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,sDAAsD;EACtD,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,QAAQ,iBAAiB,EAAE;;AAE3B;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".dashboard-layout { \n  display: flex;  \n  min-height: 100vh;  \n  background-color: #0f172a;\n}\n\n.sidebar { \n  width: 250px; \n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%); \n  color: #ffffff; \n  position: fixed; \n  top: 0; \n  left: 0; \n  bottom: 0; \n  z-index: 1000; \n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1); \n  transform: translateX(-100%); \n  display: flex; \n  flex-direction: column; \n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 10px 0 30px rgba(0, 0, 0, 0.3); \n  overflow: hidden;\n}\n\n.sidebar-divider {\n  padding: 15px 20px 5px;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #6c757d;\n  font-weight: bold;\n  letter-spacing: 1px;\n  border-top: 1px solid #343a40;\n  margin-top: 10px;\n}\n\n.admin-nav-item .nav-icon.text-warning {\n  color: #ffc107;\n}\n\n.sidebar.visible { transform: translateX(0); }\n\n.sidebar-header { \n  padding: 25px 15px;\n  background: rgba(255, 255, 255, 0.02);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05); \n}\n\n.brand-container { display: flex; flex-direction: column; align-items: center;  justify-content: center; text-align: center; }\n.sidebar-logo { height: 40px;  width: auto; margin-bottom: 12px; filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3)); }\n.brand-slogan { font-size: 12px; font-weight: 400; color: #94a3b8; margin: 0; line-height: 1.4; font-style: italic; max-width: 190px; }\n\n.sidebar-nav { \n  flex: 1; \n  padding: 15px 12px; \n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.nav-item { \n  display: flex; \n  align-items: center; \n  padding: 10px 14px; \n  color: #94a3b8; \n  text-decoration: none; \n  border-radius: 10px; \n  transition: all 0.3s ease; \n  font-size: 14px; \n  font-weight: 500;\n}\n\n.nav-item:hover { \n  background-color: rgba(59, 130, 246, 0.1); \n  color: #3b82f6; \n  padding-left: 18px;\n}\n\n.nav-icon {\n  width: 20px;\n  margin-right: 12px;\n  font-size: 1.1rem;\n}\n\n.sidebar-toggle-btn {\n  position: fixed;\n  top: 15px;\n  z-index: 1100;\n  width: 32px;\n  height: 32px;\n  background-color: #ffffff;\n  color: #1e293b;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  /* JS inline style left handle korbe (15px or 235px) */\n  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s;\n}\n\n.sidebar-toggle-btn:hover {\n  background-color: #38bdf8;\n  color: white;\n}\n\n.main-content {\n  flex: 1;\n  padding: 30px;\n  padding-top: 70px;\n  transition: margin-left 0.3s ease;\n  width: 100%;\n}\n\n.sidebar-footer {\n  padding: 10px;\n  background-color: #0f172a;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.lang-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.lang-box select {\n  background: #1e293b;\n  color: #fff;\n  border: 1px solid #334155;\n  border-radius: 6px;\n  padding: 4px 8px;\n  outline: none;\n  cursor: pointer;\n}\n\n.logout-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background 0.2s;\n}\n\n.logout-button:hover {\n  background-color: #dc2626;\n}\n\n.mr-2 { margin-right: 8px; }\n\n@media (min-width: 769px) {\n  .sidebar-open {\n    margin-left: 240px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
